/* eslint-disable max-lines */
/* eslint-disable max-statements */
/* eslint-disable react-hooks/exhaustive-deps */
// Actions
import { setEntityDataSuccess } from 'containers/MerchantOnboard/redux/editMerchant/editMerchant.actions';

import {
    fetchEntityHierarchyRequest,
    fetchEntityListRequest,
} from 'containers/MerchantOnboard/redux/merchantOnBoard.actions';

import {
    fetchMandatesRequest,
    getActiveMandateReportRequest,
    downloadMandateReportRequest,
    generateMandateReportError,
    generateMandateReportRequest,
    resetMandateTransactionList,
} from 'containers/Mandate/redux/mandates.actions';

// Components
import DownloadFile from 'containers/Transactions/DownloadFile';

import { setAggregatorFilter, setMerchantFilter } from 'utils/helperMethods';

import { ENTITY_TYPE } from '../../utils/constants/commonValues';

import {
    Table,
    TableFilter,
    Popup,
    ViewDownloadGeneric,
    TableSearch,
} from '../../components';

// Constants

import {
    MANDATE_COLUMNS,
    MANDATE_PAYMENT_MODE,
    MANDATE_STATUS_ENUM,
} from './constant';

// Component
import MandateActions from './MandateActions';

// Libraries

import React, {
    useMemo,
    useState,
    useCallback,
    useEffect,
    useRef,
} from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';

// Layouts

// Styles
import './mandate.scss';

let filterFieldList = [
    {
        fieldType: 'date',
        label: 'Date Range',
        name: 'createdOn',
        props: {
            startDate: moment()
                .endOf('day')
                .subtract(1, 'days'),
            endDate: moment().endOf('day'),
            maximumNights: 30,
            notResetDate: true,
        },
    },

    {
        fieldType: 'search-select',
        label: 'Aggregator Name',
        name: 'aggregatorId',
        props: {
            data: [],
            label: 'Select Aggregator',
            labelField: 'name',
            valueField: 'entityCode',
            entityType: 'AGGREGATOR',
        },
    },
    {
        fieldType: 'search-select',
        label: 'Merchant Name',
        name: 'merchantName',
        props: {
            data: [],
            label: 'Select Merchant',
            labelField: 'name',
            valueField: 'entityCode',
            entityType: 'MERCHANT_NAME',
        },
    },
    {
        fieldType: 'search-select',
        label: 'Merchant ID',
        name: 'merchantId',
        props: {
            data: [],
            label: 'Select Merchant',
            labelField: 'entityCode',
            valueField: 'entityCode',
            entityType: 'MERCHANT',
        },
    },
    {
        fieldType: 'parallel-input',
        label: 'Amount',
        fieldA: {
            name: 'minAmount',
            props: {
                placeholder: 'Min. Amount',
                type: 'number',
            },
        },
        fieldB: {
            name: 'maxAmount',
            props: {
                placeholder: 'Max. Amount',
                type: 'number',
            },
        },
    },
    {
        fieldType: 'search-select',
        label: 'Payment Type',
        name: 'paymentType',
        props: {
            data: MANDATE_PAYMENT_MODE,
            label: 'Select Payment Type',
            labelField: 'name',
            valueField: 'value',
        },
    },
    {
        fieldType: 'checkbox',
        label: 'Mandate Status',
        name: 'mandateStatus',
        props: {
            options: MANDATE_STATUS_ENUM,
            labelField: 'name',
            valueField: 'value',
        },
    },
];

const Mandates = props => {
    const {
        mandateData,
        actions,
        // staticData,
        loader: { showLoader },
        merchantData,
        auth,
    } = props;

    const {
        error,
        tableData,
        isLoading,
        pagination,
        generatedFile,
        activeReports,
    } = mandateData;

    const { entityList } = merchantData;
    // const { underlyingMerchant } = staticData;
    const [filterData, setFilterData] = useState({});
    const { userLevel, associatedEntityId } = auth.userDetails;

    const columns = useMemo(() => MANDATE_COLUMNS, []);

    const pageSizeOptions = [10, 20, 40, 60];

    // We'll start our table without any data
    const [pageCount, setPageCount] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [isResetPage, setIsResetPage] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [showDownloadPopup, setShowDownloadPopup] = useState(false);
    const selectedAggregator = useRef(null);

    const handleViewDownloads = () => {
        setShowFilter(true);
    };

    const handleCloseViewDownloads = () => {
        setShowFilter(false);
    };

    const handleAggregatorSelect = useCallback(
        entityCode => {
            selectedAggregator.current = entityCode;
            if (!entityCode) {
                // used to rerender so all merchant visible
                setFilterData({
                    createdOn: filterData.createdOn,
                });
                return;
            }
            actions.fetchEntityHierarchyRequest(
                entityCode,
                'LOWER_COMPLETE',
                'AGGREGATOR_TXN'
            );
        },
        [actions]
    );

    useEffect(() => {
        // get all aggregator
        actions.fetchEntityListRequest(ENTITY_TYPE.AGGREGATOR);
        actions.fetchEntityListRequest(ENTITY_TYPE.MERCHANT);
        // add onchange listener to aggregator
        filterFieldList.forEach(filter => {
            if (filter.name === 'aggregatorId') {
                filter.props.onChange = handleAggregatorSelect;
            }
        });
    }, [actions, handleAggregatorSelect]);

    useEffect(() => {
        if (generatedFile.isSuccess) {
            setShowFilter(true);
            setShowDownloadPopup(false);
        }
        return () => {
            actions.generateMandateReportError({ error: {} });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [generatedFile.isSuccess]);

    // remove filters for specific users
    useEffect(() => {
        // if not admin and RM remove aggregator
        if (userLevel && userLevel !== 'ADMIN' && userLevel !== 'RM') {
            filterFieldList = filterFieldList.filter(
                filter => filter.name !== 'aggregatorId'
            );
        }
        // if merchant remove merchant
        if (userLevel && userLevel === 'MERCHANT') {
            filterFieldList = filterFieldList.filter(
                filter => filter.name !== 'merchantId'
            );
        }

        if (userLevel) {
            // for aggregator request only when auth data is present
            fetchData({ pageIndex: 0, pageSize: 10 });
        }
    }, [userLevel]);

    const fetchData = ({ pageSize, pageIndex }) => {
        // This will get called when the table needs new data
        // You could fetch your data from literally anywhere,

        const data = {
            pageSize,
            pageIndex,
        };
        if (
            filterData.createdOn &&
            Object.keys(filterData.createdOn).length &&
            userLevel
        ) {
            // for aggregator show split txn in default view
            if (userLevel === 'AGGREGATOR' && !filterData.merchantIds) {
                actions.fetchMandatesRequest({
                    ...data,
                    ...filterData,
                    merchantIds: [associatedEntityId],
                });
            } else {
                actions.fetchMandatesRequest({
                    ...data,
                    ...filterData,
                });
            }
        }
        setPageSize(pageSize);
    };

    useEffect(() => {
        setPageCount(Math.ceil(pagination.totalNumberOfRecords / pageSize));
    }, [pageSize, pagination.totalNumberOfRecords]);

    const handleSearchSubmit = searchQuery => {
        actions.fetchMandatesRequest({
            orderId: searchQuery,
            createdOn: filterData.createdOn,
        });
    };

    const handleSearchEnd = (value, entityType) => {
        const type = entityType === 'MERCHANT_NAME' ? 'MERCHANT' : entityType;
        const filtered = entityList[type.toLowerCase()]?.filter(item => {
            const key = entityType === 'MERCHANT' ? 'entityCode' : 'name';
            return item[key]?.toLowerCase().includes(value.toLowerCase());
        }) || [];

        const data = {
            entityName: ['MERCHANT_NAME', 'AGGREGATOR'].includes(entityType) ? value : '',
            entityCode: !['MERCHANT_NAME', 'AGGREGATOR'].includes(entityType) ? value : ''
        };

        if (filtered.length === 0 && value.length >= 3) {
            actions.fetchEntityListRequest(type, data);
        }
    };

    let filters = setMerchantFilter(
        filterFieldList,
        entityList.merchant || [],
        entityList,
        selectedAggregator.current,
        handleSearchEnd
    );

    filters = setAggregatorFilter(filterFieldList, entityList, handleSearchEnd);

    const filterSubmitHandler = filterValues => {
        const { aggregatorId, merchantId, merchantName } = filterValues;
        delete filterValues.merchantIds;
        let merchantIds = [];
        if (aggregatorId) {
            merchantIds.push(aggregatorId);
        }
        if (merchantId) {
            merchantIds.push(merchantId);
        }
        if(merchantName){
            merchantIds.push(merchantName);
        }
        if (merchantIds.length) {
            merchantIds = [...new Set(merchantIds)];
            filterValues.merchantIds = merchantIds;
        }
        setFilterData({ ...filterValues, isLive: filterData.isLive });
        setIsResetPage(true);
    };

    return (
        <div className="mandate-wrapper">
            <Table
                tableTitle="Mandate View"
                filterActionTitle="View Downloads"
                columns={columns}
                isFiltersEnable
                isPaginationEnable
                data={tableData}
                filterData={filterData}
                error={error && error.errorMessage}
                loading={showLoader || isLoading}
                pageCount={pageCount}
                fetchData={fetchData}
                numberOfRecord={pagination.totalNumberOfRecords}
                pageSizeOptions={pageSizeOptions}
                paginationLabel="Rows per page"
                pagePerView={3}
                isResetPage={isResetPage}
                afterResetPage={() => setIsResetPage(false)}
                onClickTableAction={handleViewDownloads}
                tableSearch={
                    <div className="search">
                        <div>
                            <TableSearch
                                handleSearchSubmit={handleSearchSubmit}
                                placeholder="Subscription ID or Customer ID"
                            />
                        </div>
                    </div>
                }
                userActions={data => (
                    <MandateActions
                        data={data}
                        resetMandateTransactionList={
                            actions.resetMandateTransactionList
                        }
                    />
                )}
                additionalActions={() => (
                    <DownloadFile
                        filterData={filterData}
                        tableData={tableData}
                        actions={{
                            ...actions,
                            generateReportRequest:
                                actions.generateMandateReportRequest,
                        }}
                        showDownloadPopup={showDownloadPopup}
                        setShowDownloadPopup={setShowDownloadPopup}
                        generateData={generatedFile}
                    />
                )}
                tableActionPopup={
                    <Popup
                        title="Download Status"
                        showCloseIcon
                        showOverlay
                        showFilter={showFilter}
                        closePopup={handleCloseViewDownloads}
                    >
                        <ViewDownloadGeneric
                            data={activeReports.reports}
                            downloadReportRequest={
                                actions.downloadMandateReportRequest
                            }
                            getActiveReportRequest={
                                actions.getActiveMandateReportRequest
                            }
                        />
                    </Popup>
                }
                tableFilters={
                    <TableFilter
                        customFilterClass="rightSkewed"
                        showOverlay
                        fieldsList={filters}
                        onSubmit={filterValues => {
                            filterSubmitHandler(filterValues);
                        }}
                        onReset={resetValue => {
                            setFilterData({
                                ...resetValue,
                            });
                            selectedAggregator.current = null;
                            setIsResetPage(true);
                        }}
                    />
                }
            />
        </div>
    );
};

const mapStateToProps = ({
    auth,
    mandateData,
    loader,
    staticData,
    merchantData,
}) => ({
    auth,
    mandateData,
    loader,
    staticData,
    merchantData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchMandatesRequest,
            generateMandateReportError,
            setEntityDataSuccess,
            fetchEntityListRequest,
            fetchEntityHierarchyRequest,
            downloadMandateReportRequest,
            getActiveMandateReportRequest,
            generateMandateReportRequest,
            resetMandateTransactionList,
        },
        dispatch
    ),
});

Mandates.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    data: PropTypes.object,
    mandateData: PropTypes.object,
    staticData: PropTypes.object,
    loader: PropTypes.object,
    merchantData: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Mandates);
